import { render, staticRenderFns } from "./RuleDeleteModal.vue?vue&type=template&id=4acaa22b&"
import script from "./RuleDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./RuleDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./RuleDeleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports